import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, useMap, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import locationImg from "../../assets/locationIconFilled.png";

import { Modal, Row } from "react-bootstrap";
import FullscreenMap from "./FullScreenMap";
// import locationImg from "../../assets/locationImg.png"

const customIcon = new L.Icon({
  iconUrl: locationImg,
  iconRetinaUrl: locationImg,
  // shadowUrl: locationImg,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

function ChangeView({ locations }) {
  const map = useMap();
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    if (locations && locations.length > 0 && isFirstLoad) {
      const bounds = L.latLngBounds(
        locations.map((location) => location.position)
      );
      map.fitBounds(bounds, { padding: [50, 50] });
      setIsFirstLoad(false);
    }
  }, [locations, map, isFirstLoad]);

  return null;
}

// ✅ Custom Hook to Handle Zoom Events
export function ZoomEvents() {
  const map = useMap();

  useEffect(() => {
    // Double click to zoom in
    const handleDoubleClick = (e) => {
      e.preventDefault();
      map.zoomIn();
    };

    // Right click to zoom out
    const handleRightClick = (e) => {
      e.preventDefault();
      map.zoomOut();
    };

    const mapElement = map.getContainer();
    mapElement.addEventListener("dblclick", handleDoubleClick);
    mapElement.addEventListener("contextmenu", handleRightClick);

    return () => {
      mapElement.removeEventListener("dblclick", handleDoubleClick);
      mapElement.removeEventListener("contextmenu", handleRightClick);
    };
  }, [map]);

  return null;
}

const Map = ({
  locations,
  onSelectLocation,
  height = "700px",
  width = "100%",
}) => {
  const [center, setCenter] = useState([56.130366, -106.346771]);
  const [fullScreenModal, setFullScreenModal] = useState(false);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      setFullScreenModal(false);
    }
  });

  const isMultipleLocations = Array.isArray(locations);


  // converting Location object 
  const locationArray = Array.isArray(locations) ? locations : [locations];
  
  return (
    <div style={{ height: height, width: width, position: "relative" }}>
      <MapContainer
        center={center}
        style={{ height: "100%", width: "100%" }}
        zoom={15}
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <ChangeView locations={locationArray} />
        <ZoomEvents />

        {locationArray.map((location) => (
          <Marker
            className="location_icon"
            key={location.id}
            position={location.position}
            icon={customIcon}
            eventHandlers={{
              click: () => {
                onSelectLocation(location);
              },
            }}
          >
            {/* <Popup>
              <div className="popup-content">
                <img
                  src={location.image || "/placeholder.svg"}
                  alt={location.name}
                  className="img-fluid mb-2"
                  loading="lazy"
                />
                <h5 className="font-bold mb-1">{location.name}</h5>
                <p className="popup-address mb-2">{location.address}</p>
                <p className="popup-phone">
                  <strong>Phone:</strong> {location.phone}
                </p>
              </div>
            </Popup> */}
          </Marker>
        ))}

        {/* {isMultipleLocations ? (
          locations.map((location) => (
            <Marker
              className="location_icon"
              key={location.id}
              position={[location?.latitude, location?.longitude]}
              icon={customIcon}
              eventHandlers={{
                click: () => {
                  onSelectLocation(location);
                },
              }}
            >
              <Popup>
                <div className="popup-content">
                  <img
                    src={location.image || "/placeholder.svg"}
                    alt={location.name}
                    className="img-fluid mb-2"
                    loading="lazy"
                  />
                  <h5 className="font-bold mb-1">{location.name}</h5>
                  <p className="popup-address mb-2">{location.address}</p>
                  <p className="popup-phone">
                    <strong>Phone:</strong> {location.phone}
                  </p>
                </div>
              </Popup>
            </Marker>
          ))
        ) : (
          <Marker
            className="location_icon"
            key={locations.id}
            position={[location?.latitude, location?.longitude]}
            icon={customIcon}
            // eventHandlers={{
            //   click: () => {
            //     onSelectLocation(location);
            //   },
            // }}
          >
            <Popup>
              <div className="popup-content">
                <img
                  src={locations.image || "/placeholder.svg"}
                  alt={locations.location_name}
                  className="img-fluid mb-2"
                  loading="lazy"
                />
                <h5 className="font-bold mb-1">{locations.location_name}</h5>
                <p className="popup-address mb-2">
                  {locations.location_address}
                </p>
                <p className="popup-phone">
                  <strong>Phone:</strong> {locations.phone}
                </p>
              </div>
            </Popup>
          </Marker>
        )} */}
      </MapContainer>

      {/* ✔ Fullscreen Button */}
      <button
        onClick={() => setFullScreenModal(true)}
        title="FullScreen"
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "var(--primary-bg)",
          border: "none",
          padding: "8px 12px",
          cursor: "pointer",
          borderRadius: "4px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        }}
      >
        <i className="bi bi-arrows-fullscreen"></i>
      </button>

      {/*✔ Full Screen Modal  */}
      <Modal
        fullscreen={true}
        centered
        show={fullScreenModal}
        className="modal-fullscreen"
      >
        <div className="modal-body p-0 overflow-hidden">
          <Row>
            <FullscreenMap
              locations={locationArray}
              setFullScreenModal={setFullScreenModal}
            />
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default Map;
